function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 125,
  r: 100,
  fill: "url(#paint0_radial)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 125,
  r: 100,
  fill: "url(#paint1_radial)"
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 74.5,
  cy: 115.5,
  r: 10.5,
  fill: "#4F4D48"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 180.5,
  cy: 115.5,
  r: 10.5,
  fill: "#4F4D48"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M107.813 151.5C105.707 151.5 103.95 149.752 104.614 147.753C104.904 146.879 105.297 146.02 105.789 145.186C106.97 143.184 108.701 141.365 110.883 139.833C113.065 138.301 115.656 137.085 118.507 136.256C121.358 135.427 124.414 135 127.5 135C130.586 135 133.642 135.427 136.493 136.256C139.344 137.085 141.935 138.301 144.117 139.833C146.299 141.365 148.03 143.184 149.211 145.186C149.703 146.02 150.096 146.879 150.386 147.753C151.05 149.752 149.293 151.5 147.187 151.5C145.081 151.5 143.425 149.712 142.487 147.827C142.388 147.628 142.281 147.43 142.166 147.235C141.368 145.882 140.199 144.654 138.725 143.619C137.251 142.584 135.501 141.763 133.575 141.203C131.649 140.643 129.585 140.354 127.5 140.354C125.415 140.354 123.351 140.643 121.425 141.203C119.499 141.763 117.749 142.584 116.275 143.619C114.801 144.654 113.632 145.882 112.834 147.235C112.719 147.43 112.612 147.628 112.513 147.827C111.575 149.712 109.919 151.5 107.813 151.5Z",
  fill: "#4F4D48"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 15,
  width: 256,
  height: 256,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 12,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 18
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.992157 0 0 0 0 0.796078 0 0 0 0 0.356863 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d",
  x: 0,
  y: 0,
  width: 256,
  height: 256,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 12,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.992157 0 0 0 0 0.796078 0 0 0 0 0.356863 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-11 68) rotate(21.3916) scale(220.705)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.42
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.230076,
  stopColor: "#FFE927"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.642194,
  stopColor: "#FFE43B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.989483,
  stopColor: "#FFD66D"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-11 68) rotate(21.3916) scale(220.705)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.42
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.230076,
  stopColor: "#FFE927"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.642194,
  stopColor: "#FFE43B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.989483,
  stopColor: "#FFD66D"
})));

var SvgSadFace = function SvgSadFace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 271,
    viewBox: "0 0 256 271",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSadFace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SadFace.f9760b47.svg";
export { ForwardRef as ReactComponent };